/**
 * 判断是否为移动端(Mobile)
 * @returns {Boolean} 判断结果
 */
export const isEnvMobile = () => {
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
}

export const isIos = () => {
  const UA_IOS_REG = /\b(iPad|iPhone|iPod)\b.*? OS /;
  return UA_IOS_REG.test(navigator.userAgent);
}

/**
 * 获取链接具体参数
 * @param {String} name 参数key
 * @param {String} url 链接
 * @returns 
 */
export const getParamFromUrlHashByKey = (name, url = location.hash) => {
  // eslint-disable-next-line
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || ''
}


/*
 * 设置cookie
 */
export const setCookie = (cookieName, cookieValue, daysToExpire) => {
  const date = new Date()
  date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000))
  document.cookie = cookieName + '=' + cookieValue + '; expires=' + date.toGMTString() + '; path=/'
}

/*
 * 获取cookie
 */
export const getCookie = (cookie) => {
  const cookieArr = document.cookie.split(';')
  let obj = {}
  if (cookie) {
    for (let key in cookieArr) {
      let temp = cookieArr[key].split('=')
      obj[temp[0].replace(/\s+/g, '')] = temp[1]
    }
    if (Object.keys(obj).indexOf(cookie) > -1) {
      return obj[cookie]
    } else {
      return false
    }
  }
  return false
}

export function scrollBarWidthFn() {
  const outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);
  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';
  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  const widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  const scrollBarWidth = widthNoScroll - widthWithScroll;
  return scrollBarWidth;
};

/**
 * 监听页面是否可见 (仅在浏览器中生效)
 * setupMedia(()=>{}, ()=>{})
 * funcShow: 页面显示时 需要执行的方法
 * funcHide: 页面隐藏时 需要执行的方法
 */
export const ListenBrowserPageStatus = (funcShow = null, funcHide = null) => {
  let state;
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    // hidden = "hidden";
    visibilityChange = 'visibilitychange';
    state = 'visibilityState';
  } else if (typeof document.mozHidden !== 'undefined') {
    // hidden = "mozHidden";
    visibilityChange = 'mozvisibilitychange';
    state = 'mozVisibilityState';
  } else if (typeof document.msHidden !== 'undefined') {
    // hidden = "msHidden";
    visibilityChange = 'msvisibilitychange';
    state = 'msVisibilityState';
  } else if (typeof document.webkitHidden !== 'undefined') {
    // hidden = "webkitHidden";
    visibilityChange = 'webkitvisibilitychange';
    state = 'webkitVisibilityState';
  }

  document.addEventListener(
    visibilityChange,
    () => {
      if (document[state] === 'visible') {
        // 页面显示
        typeof funcShow === 'function' && funcShow();
      } else {
        // 页面切换到后台
        typeof funcHide === 'function' && funcHide();
      }
    },
    false,
  );
};